/**
 * @module ol/ImageState
 */
/**
 * @enum {number}
 */
export default {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4,
};
//# sourceMappingURL=ImageState.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/ImageState.js
// module id = 115
// module chunks = 8